
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 18","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-copy)"}},[_c('path',{attrs:{"d":"M13.143 8.5a.571.571 0 00-.572.572v5.714a.571.571 0 01-.571.571H1.714a.571.571 0 01-.571-.571V3.357c0-.315.256-.571.571-.571h6.857a.571.571 0 100-1.143H1.714C.768 1.643 0 2.411 0 3.357v11.429c0 .947.768 1.714 1.714 1.714H12c.947 0 1.714-.768 1.714-1.714V9.072a.571.571 0 00-.571-.572z"}}),_c('path',{attrs:{"d":"M15.36 1.14a2.187 2.187 0 00-3.093.001L4.74 8.667a.578.578 0 00-.138.224l-1.143 3.428a.571.571 0 00.722.723L7.61 11.9a.572.572 0 00.223-.138l7.527-7.527a2.187 2.187 0 000-3.093zm-.808 2.287l-7.428 7.428-2.22.741.74-2.216 7.43-7.429a1.045 1.045 0 011.478 1.476z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-copy"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    